import { render, staticRenderFns } from "./FeedInfo.vue?vue&type=template&id=7c1860b5&scoped=true"
import script from "./FeedInfo.vue?vue&type=script&lang=js"
export * from "./FeedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1860b5",
  null
  
)

export default component.exports